import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import Checkbox from './Checkbox';

class CheckboxGroup extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {

    const value = event.target.value;
    const selected = this.props.selected;

    let valueArray = [];
    if (selected.indexOf(value) > -1) {
      valueArray = selected.filter(s => s !== value)
    } else {
      valueArray = [...selected, value];
    }

    this.props.onChange(this.props.name, valueArray);
  }

  render() {

    const separator = this.props.vertical ? <br /> : '';

    return (
      <Fragment>
        {this.props.items.map(item =>
          <Fragment key={item[this.props.keyField]}>
            <Checkbox
              name={this.props.name}
              value={item[this.props.keyField]}
              checked={this.props.selected.indexOf(item[this.props.keyField].toString()) > -1}
              onChange={this.handleChange}
              label={item[this.props.valueField]} />
            {separator}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

CheckboxGroup.defaultProps = {
  vertical: true,
  keyField: "id",
  valueField: "name"
};

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  vertical: PropTypes.bool,
  selected: PropTypes.array,
  keyField: PropTypes.string,
  valueField: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/form/controls/CheckboxGroup.js